<template>
    <v-container>
        <v-form ref="diskPaintForm" v-model="valid" lazy-validation>
            <v-row>
                <v-col cols="12" sm="3">
                    <ChooseOfWheels v-model="wheels" />
                </v-col>
                <v-col cols="12" sm="9">
                    <v-card flat>
                        <v-tabs v-model="tab">
                            <v-tab
                                v-for="item in tabs"
                                :key="item.key"
                                @click="isFirstTab = false"
                            >
                                <v-img
                                    :src="icon[item.icon]"
                                    aspect-ratio="2"
                                    contain
                                    class="tabs_icons"
                                ></v-img>
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="item in tabs" :key="item.key">
                                <v-card flat class="main_bg_color">
                                    <v-card-text class="pt-1 pb-0">
                                        <v-btn-toggle
                                            v-model="paintType"
                                            dense
                                            mandatory
                                            background-color="primary"
                                            class="change_dtype mt-2 mb-3"
                                        >
                                            <v-btn
                                                v-for="(paint,
                                                index) in paintTypeList"
                                                :key="paint.id"
                                                @click="
                                                    setPaintType({
                                                        index: index,
                                                        side: item.key
                                                    })
                                                "
                                            >
                                                <span
                                                    class="hidden-sm-and-down"
                                                    >{{
                                                        paint.short_name
                                                    }}</span
                                                >
                                            </v-btn>
                                        </v-btn-toggle>
                                        <p class="subtitle-1 mb-0">Колеса</p>
                                        <wheelRadius
                                            :side="item.key"
                                            source="paint"
                                        />
                                        <chooseColor
                                            :side="item.key"
                                            :paintType="paintType"
                                        />
                                        <paintOptionsNew
                                            :side="item.key"
                                            :paintType="paintType"
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="9" class="result-text">
                    <p
                        v-for="(item, index) in getTotalWheelsInfo(showActive)"
                        :key="index"
                    >
                        {{ "[" + item.x.side + "] " + item.text }}
                    </p>
                </v-col>
                <v-col cols="12" sm="3" class="pt-0">
                    <div class="price mb-3">
                        <span class="fullprice" v-if="discount > 0">
                            {{ numberWithSpaces(totalPriceFull) }} ₽
                        </span>
                        <span class="discount" v-if="discount > 0">
                            -{{ discount }}%
                        </span>
                        <span class="discountprice">
                            {{ numberWithSpaces(totalPrice) }} ₽
                        </span>
                    </div>
                    <v-btn
                        large
                        color="#C8FA92"
                        block
                        @click="addServiceToCart()"
                    >
                        Добавить
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
// @ is an alias to /src
import ChooseOfWheels from "./ChooseOfWheels";
import wheelRadius from "./wheelRadius";
import paintOptionsNew from "./diskPaint/paintOptionsNew";
import chooseColor from "./diskPaint/chooseColor";
// import helpers from "../../../store/modules/helpers";

export default {
    props: ["itemID"],
    components: {
        ChooseOfWheels,
        wheelRadius,
        chooseColor,
        paintOptionsNew
    },
    computed: {
        icon() {
            return this.$store.state.imgs.icon;
        },
        carType() {
            return this.$store.state.clientCard.carType;
        },
        paintTypeList() {
            return this.$store.state.paint.paintTypes.filter(x => x.id != 4);
        },
        paintOptions() {
            return this.$store.state.paint.options;
        },
        discount() {
            return 0; // this.$store.state.clientIdentify.client.discount.value * 100 // нет скидок в покраске вообще
        },
        showActive() {
            let active = [];
            const wheelsName = [
                "forwardLeft",
                "forwardRight",
                "backLeft",
                "backRight",
                "spareLeft",
                "spareRight"
            ];
            const wheelsNameRus = [
                "Переднее левое",
                "Переднее правое",
                "Заднее левое",
                "Заднее правое",
                "Запасное левое",
                "Запасное правое"
            ];
            wheelsName.forEach((key, index) => {
                if (
                    this.$store.state.paint.wheels[key] &&
                    this.$store.state.paint.wheels[key].isActive
                ) {
                    active.push({
                        name: wheelsNameRus[index],
                        data: this.$store.state.paint.wheels[key]
                    });
                }
            });
            return active;
        },
        tabs() {
            let res = [];
            const icons = ["fl", "fr", "bl", "br", "sl", "sr"];
            let i = 0;
            for (const key in this.wheels) {
                if (this.wheels[key]) {
                    res.push({ key: key, icon: icons[i], slot: icons[i] });
                }
                i++;
            }
            return res;
        },
        QRcodeUrl() {
            return this.$store.state.repair.QRcodeUrl;
        },
        wheels: {
            get() {
                return {
                    forwardLeft: this.$store.state.paint.wheels.forwardLeft
                        .isActive,
                    forwardRight: this.$store.state.paint.wheels.forwardRight
                        .isActive,
                    backLeft: this.$store.state.paint.wheels.backLeft.isActive,
                    backRight: this.$store.state.paint.wheels.backRight
                        .isActive,
                    spareLeft: this.$store.state.paint.wheels.spareLeft
                        .isActive,
                    spareRight: this.$store.state.paint.wheels.spareRight
                        .isActive
                };
            },
            set(value) {
                this.$store.dispatch("paint/changeActiveWheels", [
                    value,
                    this.canChange
                ]);
            }
        },
        firstColor: {
            get() {
                return this.$store.state[this.source].wheels[this.side].data
                    .firstColor;
            },
            set(value) {
                this.$store.commit(this.source + "/setPlus", {
                    side: this.side,
                    value,
                    item: "firstColor"
                });
            }
        },
        firstVarnish: {
            get() {
                return this.$store.state[this.source].wheels[this.side].data
                    .firstVarnish;
            },
            set(value) {
                this.$store.commit(this.source + "/setPlus", {
                    side: this.side,
                    value,
                    item: "firstVarnish"
                });
            }
        },
        secondColor: {
            get() {
                return this.$store.state[this.source].wheels[this.side].data
                    .secondColor;
            },
            set(value) {
                this.$store.commit(this.source + "/setPlus", {
                    side: this.side,
                    value,
                    item: "secondColor"
                });
            }
        },
        secondVarnish: {
            get() {
                return this.$store.state[this.source].wheels[this.side].data
                    .secondVarnish;
            },
            set(value) {
                this.$store.commit(this.source + "/setPlus", {
                    side: this.side,
                    value,
                    item: "secondVarnish"
                });
            }
        },
        isFirstTab: {
            get() {
                return this.$store.state[this.source].isFirstTab;
            },
            set(value) {
                this.$store.commit(this.source + "/setIsFirstTab", value);
            }
        }
    },
    data() {
        return {
            canChange: true,
            source: "paint",
            nameRules: [v => !!v || "необходимо заполнить"],
            valid: true,
            quantity: null,
            allValues: [],
            paintType: 0,
            paintTypeList1: [
                { id: 0, title: "Порошковая" },
                { id: 1, title: "Акриловая" },
                { id: 2, title: "Покрыть лаком" }
            ],
            totalPrice: null,
            totalPriceFull: null,
            resultText:
                "Ремонт бокового пореза шины размером 3х5 мм, заплатка «Стандарт» с применением горячей вулканизации с восстановлением защитной кромки",
            tab: null,
            panel: 0,
            title: "Покраска дисков",
            myInputModel: "",
            dropped: true,
            opTile: [
                "argonWelding",
                "capPaint",
                "corrosionDamage",
                "diamondGroove",
                "diskEditing",
                "engraving",
                "firstColor",
                "firstVarnish",
                "isRunflat",
                "prefabricatedDisc",
                "removeChrome",
                "solidDisk",
                "twoColors"
            ]
        };
    },
    methods: {
        async addServiceToCart() {
            if (this.$refs.diskPaintForm.validate()) {
              let service = this.$store.getters.services[this.itemID];
              service.addText = this.allValues;
              for (let i=0; i < this.allValues.length; i++) {
                const x = this.allValues[i]
                let options = {};
                    console.log("x", x);
                    for (let val in x.x.options) {
                        options[x.x.optionsQ[val]] = {
                            id: this.$store.state.paint.options[val].id,
                            name: this.$store.state.paint.options[val].name,
                            status: x.x.options[val],
                            quantity: x.x.optionsQ[val]
                        };
                    }
                    await this.$store.dispatch("addServiceToCart", {
                        service: service,
                        client: this.$store.getters.client,
                        quantity: x.x.quantity,
                        description: '[' + x.x.side + '] ' + x.text,
                        price: x.price,
                        params: {
                            diskType: x.x.solidDisk
                                ? "Литой диск"
                                : "Штампованый диск",
                            diskR: "R" + x.x.radius,
                            carType: this.carType,
                            wheelSide: x.x.name,
                            isRunflat: x.x.isRunflat,
                            text: '[' + x.x.side + '] ' + x.text,
                            content: x,
                            options: options,
                            description:
                                this.$store.state.paint.paintTypes[
                                    x.x.paintTypes
                                ].short_name +
                                " R" +
                                x.x.radius
                        }
                    });
                }
            }
        },
        sideOptions(val) {
            return this.$store.state.paint.wheels[val].data.options;
        },
        setPaintType(value) {
            console.log("new paint", value);
            if (value.index == 3) {
                if (this.showActive.length < 4) {
                    this.wheels = {
                        backLeft: true,
                        backRight: true,
                        forwardLeft: true,
                        forwardRight: true,
                        spareLeft: false,
                        spareRight: false
                    };
                    this.canChange = false;
                }

                console.log("sss", this.showActive.length);
            } else {
                this.canChange = true;
            }
            this.$store.commit("paint/diskPaintType", value);
        },
        numberWithSpaces(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            }
        },
        infoClick() {
            this.showInfo = !this.showInfo;
            // console.log('infotext')
        },
        getTotalWheelsInfo(value) {
            console.log("getTotalWheelsInfo", value);
            this.quantity = null;
            let allValues = [];
            let totalPrice = 0;
            let optionsPriseList = this.$store.state.paint.options;
            value.forEach(x => {
                console.log('paint:L',x)
                let name = x.name;
                x = x.data.data;
                x.side = this.shortSidename(name);
                x.name = name;
                let radtext = x.radius ? "R" + x.radius + " " : "";
                let text = radtext;
                let price = 0;
                // console.log(this.$store.state.paint.paintTypes[x.paintTypes])
                if (
                    x.radius &&
                    this.$store.state.paint.paintTypes[x.paintTypes] &&
                    this.$store.state.paint.paintTypes[x.paintTypes].powder
                ) {
                    price = parseInt(
                        this.$store.state.paint.paintTypes[
                            x.paintTypes
                        ].powder.find(v => v.radius == x.radius).price
                    );
                    text =
                        text +
                        this.$store.state.paint.paintTypes[x.paintTypes].name + ',';
                }
                if (x.firstColor) {
                    if (x.options[2]) {
                        text =
                            text +
                            " цвет: " +
                            x.firstColor +
                            ", лак: " +
                            x.firstVarnish;
                        text =
                            text +
                            ", цвет 2: " +
                            x.secondColor +
                            ", лак 2: " +
                            x.secondVarnish;
                    } else {
                        text =
                            text +
                            " цвет: " +
                            x.firstColor +
                            ", лак: " +
                            x.firstVarnish;
                    }
                }
                let optionsText = null
                for (let opt in x.options) {
                    if (x.options[opt] == true) {
                        if (optionsPriseList[opt].multi > 100) {
                            price = price * (optionsPriseList[opt].multi / 100);
                        }
                        if (optionsPriseList[opt].options.length > 0) {
                            price =
                                price +
                                optionsPriseList[opt].options.find(
                                    v =>
                                        v.radius == x.radius ||
                                        (x.radius >= v.r_min &&
                                            x.radius <= v.r_max)
                                ).price;
                        }
                        if (optionsPriseList[opt].summ > 0) {
                            let summ = optionsPriseList[opt].summ;
                            if (optionsPriseList[opt].is_numerable)
                                summ = summ * x.optionsQ[opt];
                            price = price + summ;
                        }
                        if (optionsText) {
                            optionsText = optionsText + ', ' + optionsPriseList[opt].name
                        } else {
                            optionsText = optionsPriseList[opt].name
                        }
                    }
                }
                if (optionsText) {
                    text = text + ', ' + optionsText + '.'
                } else {
                    text = text + '.'
                }
                totalPrice = totalPrice + price;
                if (price == 0) {
                    text = "";
                }
                // if ( text != '') {
                //     const valueToAdd = {text, price , x , id:this.$store.state.paint.paintTypes[x.paintTypes].powder.find(v=>v.radius==x.radius).id}
                //     allValues.push(valueToAdd)
                // }
                if (allValues.length > 0) {
                    const i = allValues.findIndex(val => val.text == text);
                    if (i >= 0) {
                        x.side = allValues[i].x.side + "," + x.side;
                        x.quantity = allValues[i].x.quantity + 1;
                        allValues.splice(i, 1, {
                            text,
                            x: x,
                            price: allValues[i].price
                        });
                    } else {
                        x.quantity = 1;
                        allValues.push({ text, x: x, price: price });
                    }
                } else {
                    x.quantity = 1;
                    allValues.push({ text, x: x, price: price });
                }
            });
            this.totalPrice = Math.round(
                totalPrice - (totalPrice / 100) * this.discount
            ); // нет скидок в покраске вообще
            this.totalPriceFull = Math.round(totalPrice);
            this.$store.commit("updateServicesPrice", [
                this.itemID,
                this.totalPriceFull
            ]);
            this.allValues = allValues;
            return allValues;
        },
        shortSidename(sideName) {
            const wheelsName = ["ПЛ", "ПП", "ЗЛ", "ЗП", "ЗАП1", "ЗАП2"];
            const wheelsNameRus = [
                "Переднее левое",
                "Переднее правое",
                "Заднее левое",
                "Заднее правое",
                "Запасное левое",
                "Запасное правое"
            ];
            let index = wheelsNameRus.findIndex(x => x == sideName);
            return wheelsName[index];
        },
        onTabChange() {
            if (this.isFirstTab) {
                this.$store.dispatch("copySide", this.tabs[0].slot);
            }
            this.$store.commit("paint/setIsFirstTab", false);
            this.isFirstTab = false;
        }
    },
    created() {
        this.$store.dispatch("paint/init");
        this.isFirstTab = true;
    }
};
</script>
